import React from 'react';
import {
  Flex,
  Text,
  SimpleGrid,
  Divider,
  Spacer,
  Textarea,
} from '@chakra-ui/react';
import styles from '../styles/aboutUsStyles';
import theme from '../config/color';
import style from '../components/common/style';
import {
  customSwtich,
  customInputLabel,
  customUpdateCancelBtn,
} from '../components/createAppVersionComponent/createAppVersionComponent';
import { dropdownCustom } from '../components/bannerComponents/customBannerComponents';
import { renderCopyRight } from '../components/aboutUsComponent/customCompoent';
import { MiniHeader } from '../components/common/customComponent';
import { useHistory } from 'react-router-dom';
const CreateRewardTypes = () => {
  console.log('CreateRewardTypes gg bro');
  let history = useHistory();
  return (
    <Flex
      flexDirection={'column'}
      // padding={2}
      backgroundColor={'#FAFDFB'}
      height={'80vh'}
    >
        <Flex 
      {...style.miniheader}
      marginBottom={'2%'}
      >
      {MiniHeader({
        title: 'Create Reward Types',
        path: 'Dashboard',
        onclickForRoute: () => history.push('/Dashboard'),
        path1:'Create Reward Types',
        useSlash:true,
        path2:'Create',
      })}
      </Flex>

      <Flex
        padding={'8'}
        width={'97%'}
        boxShadow={'lg'}
        alignSelf={'center'}
        alignItems={'center'}
        background={'white'}
        justifyContent={'center'}
        flexDirection={'column'}
      >
        <SimpleGrid width={'100%'} columns={1} spacingX={'50px'}>
          {customInputLabel({ title: 'Name', mandatory: true })}

          <Flex flexDirection={'row'} marginTop={4}>
            <Text
              color={theme.customColors.blackAdminColor['100']}
              fontSize="12px"
              marginBottom={'2'}
            >
              Description
            </Text>
          </Flex>
          <Textarea
            //     value={value}
            //     onChange={handleInputChange}
            size="sm"
            height={'180px'}
          />
        </SimpleGrid>

        

        {customUpdateCancelBtn({
          title1: 'Submit',
          title2: 'Cancel',
        })}
      </Flex>

      <Spacer />
      <Divider orientation="horizontal" marginTop={5} marginBottom={2} />
      <Flex position={'sticky'} marginLeft={4}>
        {renderCopyRight()}
      </Flex>
    </Flex>
  );
};

export default CreateRewardTypes;
